import { useState } from 'react'
import { Link } from 'react-router-dom'
import SpeczeLogo from '../../assets/SpeczeLogo'
import { Alert } from '../../components/ui'
import api from '../../lib/axios'

export default function ForgotPassword() {
  const [email, setEmail]     = useState('')
  const [sent, setSent]       = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState('')

  const handleSubmit = async e => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await api.post('/auth/forgot-password', { email })
      setSent(true)
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to send reset link.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{ background: 'linear-gradient(160deg, #07020f 0%, #180a3a 50%, #07020f 100%)' }}>
      <div className="absolute inset-0 stars-bg opacity-60" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] rounded-full blur-3xl bg-purple-600/15 pointer-events-none" />

      <div className="relative z-10 w-full max-w-[400px] mx-auto px-6 py-12">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-5"><SpeczeLogo size={44} /></div>
          <h1 className="font-display font-bold text-2xl text-white">Reset your password</h1>
          <p className="text-white/40 text-sm mt-1">Enter your email and we'll send a reset link</p>
        </div>

        <div className="glass-card p-7">
          {sent ? (
            <div className="text-center py-4">
              <div className="w-14 h-14 rounded-full mx-auto mb-4 flex items-center justify-center"
                style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.2), rgba(16,185,129,0.1))', border: '1px solid rgba(16,185,129,0.3)' }}>
                <svg className="w-7 h-7 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/>
                </svg>
              </div>
              <p className="font-semibold text-white mb-2">Check your email</p>
              {/* Deliberately conditional wording. The API answers identically
                  whether or not the address is registered, so that it cannot be
                  used to discover accounts; stating outright that a mail was
                  sent would leak from the UI what the API is careful not to. */}
              <p className="text-sm text-white/50">
                If <strong className="text-white">{email}</strong> is registered, a reset link is on its way.
              </p>
              <p className="text-xs text-white/30 mt-3">The link expires in 60 minutes.</p>
            </div>
          ) : (
            <>
              {error && <div className="mb-5"><Alert type="error">{error}</Alert></div>}
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="label-specze">Email address</label>
                  <input className="input-specze" type="email" required autoFocus value={email}
                    onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
                </div>
                <button type="submit" disabled={loading} className="btn-specze w-full py-3 text-white"
                  style={{ background: 'linear-gradient(135deg, #7c3aed, #a855f7)', boxShadow: '0 0 20px rgba(139,63,255,0.3)' }}>
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
              </form>
            </>
          )}
        </div>
        <p className="text-center text-sm text-white/40 mt-6">
          <Link to="/login" className="text-purple-400 hover:text-purple-300 font-semibold transition-colors">
            ← Back to sign in
          </Link>
        </p>
      </div>
    </div>
  )
}
